import React from 'react';
import Header from 'components/util/cabecario/.mixins';
import { useHelmet } from 'hooks';
import type { IRouterProps } from 'pages/orderHistory';

export const TopBar = ({ router }: IRouterProps) => {
  useHelmet({ title: ` ${process.env.REACT_APP_TITLE} - Cadastro de Formulário` });

  function goBack() {
    router.push('/formularios');
  }

  return <Header title="Cadastro de Formulário" goBack={goBack} />;
};
